import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  INSTITUTE_FEATURE_KEY,
  InstituteState,
  instituteAdapter,
} from './institute.reducer';

export const selectInstituteState = createFeatureSelector<InstituteState>(
  INSTITUTE_FEATURE_KEY,
);

const { selectAll, selectEntities } = instituteAdapter.getSelectors();

export const selectAllInstitutes = createSelector(
  selectInstituteState,
  (state: InstituteState) => selectAll(state),
);

export const selectInstituteEntities = createSelector(
  selectInstituteState,
  selectEntities,
);
